/**
 * Created by hbentaher on 23/08/2017.
 */
export class ReferentialValueModel {
  public category: string;
  public label: string;
  public order: number;
  public id: number;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
